module.exports = __webpack_public_path__ + "static/media/nissan.bb924813.png";